import {
  ModuleIdentifier,
  useAddAttachmentsByAimIdMutation,
  useAddTransactionTeamAttachmentsMutation,
  useGetOpportunitiesQuery,
  useGetTransactionTeamsQuery,
  useLazyAttachmentsByAimIdQuery,
  useLazyOpportunityAttachmentsQuery,
  useAddOpportunityAttachmentsMutation
} from '@repo/services';

/**
 * Returns the RTK Query hook set for a given module identifier, mapping each module to its corresponding data-fetching and attachment operations.
 *
 * @param module - The module identifier that determines which set of RTK Query hooks to return.
 */
export const getModuleQuery = (module: ModuleIdentifier): any => {
  switch (module) {
    case ModuleIdentifier.aimOpportunity:
      return {
        allEntities: useGetOpportunitiesQuery,
        attachments: useLazyOpportunityAttachmentsQuery,
        addAttachments: useAddOpportunityAttachmentsMutation
      };
      break;
    case ModuleIdentifier.aimTransactionTeam:
      return {
        allEntities: useGetTransactionTeamsQuery,
        attachments: useLazyAttachmentsByAimIdQuery,
        addAttachments: useAddTransactionTeamAttachmentsMutation
      };
      break;
    case ModuleIdentifier.aimId:
      return {
        attachments: useLazyAttachmentsByAimIdQuery,
        addAttachments: useAddAttachmentsByAimIdMutation
      };
      break;
  }
};
